<ng-container *ngIf="cycle">
  <div class="page-title">
    Chame &amp; Ganhe - {{ formatReferenceMonth(cycle.referenceMonth) }}
  </div>

  <p-card>
    <form class="form-b4a">
      <span class="p-float-label">
        <input pInputText id="cycleId" [value]="cycle.giftCycleId" readonly />
        <label for="cycleId">ID do ciclo</label>
      </span>

      <span class="p-float-label">
        <input
          pInputText
          id="referenceMonth"
          [value]="formatReferenceMonth(cycle.referenceMonth)"
          readonly
        />
        <label for="referenceMonth">Mês de referência</label>
      </span>

      <span class="p-float-label">
        <input pInputText id="status" [value]="statusLabel" readonly />
        <label for="status">Status</label>
      </span>

      <span class="p-float-label">
        <input pInputText id="totalProducts" [value]="totalProducts" readonly />
        <label for="totalProducts">Produtos</label>
      </span>

      <span class="p-float-label">
        <input pInputText id="totalRules" [value]="totalRules" readonly />
        <label for="totalRules">Regras</label>
      </span>

      <div class="buttons" *ngIf="canEdit">
        <p-button
          label="Editar"
          icon="pi pi-pencil"
          [outlined]="true"
          type="button"
          (onClick)="edit()"
        />
      </div>
    </form>
  </p-card>

  <br />

  <ng-container *ngIf="cycle.gifts?.length; else emptyTpl">
    <p-fieldset *ngFor="let gift of cycle.gifts" [legend]="gift.marcoLabel">
      <p>
        {{ gift.products?.length || 0 }} produto{{ (gift.products?.length || 0) === 1 ? '' : 's' }}
        -
        {{ gift.giftRuleIds?.length || 0 }} regra{{ (gift.giftRuleIds?.length || 0) === 1 ? '' : 's' }}
      </p>

      <p-card *ngFor="let product of gift.products">
        <div class="form-b4a">
          <img
            *ngIf="product.imageUrl"
            [src]="product.imageUrl"
            [alt]="product.productName"
            width="40"
            height="40"
          />
          <span>{{ product.productName }}</span>
          <span>SKU {{ product.milleniumSku }}</span>
        </div>
      </p-card>
    </p-fieldset>
  </ng-container>

  <ng-template #emptyTpl>
    <p class="empty">Nenhum brinde cadastrado para este ciclo.</p>
  </ng-template>
</ng-container>
